<div class="hero-section">
    <app-menu-bar></app-menu-bar>
    <div class="overlay-content">
        <!-- The link sits on the left of this row while the title stays centred
             in the hero, so the two share a baseline. -->
        <div class="title-row">
            <button type="button" class="back-link" (click)="backToList()">← All equipment</button>
            @if (state === 'ready' && equipment) {
                <span class="title">{{ equipment.code }}</span>
            } @else if (state === 'loading') {
                <span class="title">Loading…</span>
            } @else {
                <span class="title">Product not found</span>
            }
        </div>
        @if (state === 'ready' && equipment?.name) {
            <span class="subtitle">{{ equipment!.name }}</span>
        }
    </div>
</div>

<section class="detail-section">
    @switch (state) {
        @case ('loading') {
            <div class="state">
                <span class="spinner" role="status" aria-label="Loading product"></span>
            </div>
        }
        @case ('not-found') {
            <div class="state">
                <p class="state-text">We don't have a product at this address. It may have been renamed or withdrawn.</p>
                <button type="button" class="primary-btn" (click)="backToList()">Browse all equipment</button>
            </div>
        }
        @case ('error') {
            <div class="state">
                <p class="state-text">Something went wrong loading this product. Please try again in a moment.</p>
                <button type="button" class="primary-btn" (click)="backToList()">Browse all equipment</button>
            </div>
        }
        @default {
            <div class="detail-grid">
                <div class="media" [class.clickable]="!!equipment?.image">
                    @if (equipment?.image) {
                        <img [src]="equipment!.image!" [alt]="equipment!.code" (click)="openImage()"
                            title="Click to view full size" />
                        <span class="zoom-hint" aria-hidden="true">Click to enlarge</span>
                    } @else {
                        <span class="no-image">No image available</span>
                    }
                </div>

                <div class="info">
                    @if (equipment?.features) {
                        <div class="block">
                            <span class="block-label">Features</span>
                            <p class="features">{{ equipment!.features }}</p>
                        </div>
                    }

                    @if (equipment!.specifications.length) {
                        <div class="block">
                            <span class="block-label">Specifications</span>
                            <dl class="specs">
                                @for (spec of equipment!.specifications; track $index) {
                                    <div class="spec-row">
                                        <dt>{{ spec.label }}</dt>
                                        <dd>{{ spec.value }}</dd>
                                    </div>
                                }
                            </dl>
                        </div>
                    } @else {
                        <p class="state-text">No published specifications for this product.</p>
                    }
                </div>
            </div>
        }
    }
</section>

<app-footer></app-footer>

<!-- Full-size product photo. Rendered only while open. -->
<ng-template #imageModal let-modal>
    <div class="image-modal-body">
        <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">&times;</button>
        <img [src]="equipment!.image!" [alt]="equipment!.code" />
        <span class="caption">{{ equipment!.code }}@if (equipment!.name) { — {{ equipment!.name }} }</span>
    </div>
</ng-template>
